import { React } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PassField from "../Inputs/PassField";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import axios from "../../axios";

export default function LoginContent() {
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Required"),
    password: Yup.string()
      .min(8, "Password must contain atleast 8 characters")
      .required("Required"),
  });
  const navigate = useNavigate();

  const loginUser = (values, setSubmitting) => {
    axios
      .post("/login", values)
      .then((response) => {
        if (response.data) {
          if (response.status === 200) {
            localStorage.clear();
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("isAdmin", response.data.user[0].isAdmin);
            localStorage.setItem(
              "isRegisterDone",
              response.data.user[0].isRegisterDone
            );
            localStorage.setItem("user", JSON.stringify(response.data.user));
            if (
              response.data.user[0].isRegisterDone ||
              response.data.user[0].isAdmin
            ) {
              navigate("/");
            } else {
              navigate("/registration-form");
            }
          } else {
            toast.warn("No response from server");
            setSubmitting(false);
          }
        }
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Something went wrong");
          console.log(error);
        }
        setSubmitting(false);
      });
  };

  return (
    <div className="row g-0 min-vh-100 align-items-center justify-content-center pt-md-0 pt-5">
      <div className="col-md-6 form-column p-lg-5 p-0">
        <h1 className="mb-4 text-center">Welcome Back!</h1>
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) =>
            loginUser(values, setSubmitting)
          }
        >
          {({ values, handleChange, handleSubmit, isSubmitting }) => (
            <Form className="forms px-lg-5 px-4" onSubmit={handleSubmit}>
              <div className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  value={values.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
                <ErrorMessage
                  name="email"
                  component="p"
                  className="error-message"
                />
              </div>
              <PassField
                placeholder="Enter your password"
                name="password"
                value={values.password}
                onChange={handleChange}
                isSubmitting={isSubmitting}
              />
              <div className="text-end">
                <Link
                  to={"/reset-password"}
                  className="link-btn link-font-size"
                  style={{ pointerEvents: isSubmitting ? "none" : "" }}
                >
                  Forgot Password
                </Link>
              </div>
              <Button
                type="submit"
                variant="primary"
                className="btn-full-width my-3"
                disabled={isSubmitting}
              >
                Login
                {isSubmitting && (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="ms-2"
                  />
                )}
              </Button>
              <p className="link-font-size">
                Don’t have an account?
                <Link
                  to={"/signup"}
                  className="link-btn ms-1"
                  style={{ pointerEvents: isSubmitting ? "none" : "" }}
                >
                  Create New
                </Link>
              </p>
            </Form>
          )}
        </Formik>
      </div>
      <div className="col-md-6 text-center py-5">
        <img
          src="/images/logo1.png"
          className="public-right-img login-cubes-img"
          alt=""
        />
      </div>
    </div>
  );
}
